import React from 'react';
import Modal from '../modal/Modal';
import TeamForm from './form';
import AcceptModal from "../accept_modal/AcceptModal";
import SearchForm from "../searchForm/SearchForm";
import { toast } from "react-toastify";
import TeamsApi from "../../api/Teams";
import LeaguesApi from "../../api/Leagues";
import AddPlayers from "./AddPlayers";
import { Link } from 'react-router-dom';
import "./teams.css";

export default class Teams extends React.Component{
    teams = [];
    leagues = [];
    constructor(){
        super();
        this.state = {
            showModal: false,
            data: [],
            modalTitle: "",
            selected: null,
            showAcceptModal: false,
            filterText: "",
            addPlayersModal: false,
            pages: 0,
            currentPage: 0,
            offset: 30
        };
    }

    componentWillMount() {
        TeamsApi.countAll().then(r => {
            let st = this.state
            let aux = Math.ceil(r.data.response[0].total / 30)
            if (aux == 0) aux = 1
            st.pages = aux
            this.setState(st);
        })
        TeamsApi.getAll(this.state.currentPage*this.state.offset,this.state.offset).then(r => {
            let st = this.state
            st.data = r.data.response.filter(t => t.status !=0)
            this.teams = r.data.response.filter(t => t.status !=0);//r.data.response;
            this.setState(st);
        });
        LeaguesApi.getAll().then(r => {
            this.leagues = r.data.response;
        }).catch(err => toast.warn('Atención, No hay ligas dadas de alta para incluir a los equipos.'));
    }

    setTeams = async(page) => {
        let st = this.state
        st.currentPage = page
        this.setState(st);
        TeamsApi.getAll(page*this.state.offset,this.state.offset).then(r => {
            let st = this.state
            st.data = r.data.response.filter(t => t.status !=0)
            this.teams = r.data.response.filter(t => t.status !=0);//r.data.response;
            this.setState(st);
        });
    }

    edit(team){
        let st = this.state
        st.modalTitle = "Editar";
        st.showModal = true;
        st.selected = team;
        this.setState(st);
    }

    closeModal(){
        let st =this.state;
        st.showModal = false;
        this.setState(st);
    }

    closeAddPlayers(){
        let state = {...this.state};
        state.addPlayersModal = false;
        this.setState(state);
    }

    save(team,closeModal=false){
        let state = {...this.state};
        if(!team.id){
            team.status = 2;
            TeamsApi.create(team).then(res => {
                state.data.push(res.data.response);
                this.setState(state);
                toast.success("El equipo se guardó correctamente");
            }).catch(err => console.log(err));
        }else{
            if(team.before_league_id  === undefined ){
                team.before_league_id = team.league_id
            }
            TeamsApi.edit(team, team.id).then(res => {
                state.data[state.data.findIndex(t => t.id === team.id)] = res.data.response;
                state.selected = null;
                this.setState(state);
                toast.success("Datos actualizados");
            })
        }
        this.teams = state.data
        state.showModal = closeModal;
    }

    create(){
        let st = this.state
        st.modalTitle = "Nuevo";
        st.showModal = true;
        st.selected = null;
        this.setState(st);
    }

    remove(){
        TeamsApi.delete(this.state.selected).then(res => {
            if(res.data.response){
                let state = {...this.state};
                state.data.splice(state.data.findIndex(t => t.id === state.selected.id),1);
                state.selected = null;
                state.showAcceptModal = false;
                this.setState(state);
                toast.success("Equipo eliminado");
            }else{
                toast.error('Ocurrió un problema, intente más tarde');
            }
        })
    }

    delete(team){
        let state = {...this.state};
        state.showAcceptModal = true;
        state.selected = team;
        this.setState(state);
    }

    handleSearchInput(text){
        let teams = this.teams.filter(team => team.team.toLowerCase().includes(text.toLowerCase())||
        team.league.toLowerCase().includes(text.toLowerCase())||
        team.tournament.toLowerCase().includes(text.toLowerCase()));
        let state = this.state;
        state.filterText = text;
        state.data = teams;
        this.setState(state);
    }

    addPlayers(team){
        let state = {...this.state};
        state.addPlayersModal = true;
        state.selected = team;
        this.setState(state);
    }

    
    render(){
        var rows = [];
        if(this.state.pages>0)
        for (var i = 1; i <= this.state.pages; i++) {
            rows.push(<li key={i} onClick={(e)=>{this.setTeams(e.currentTarget.textContent-1)}} className={(this.state.currentPage+1==i) ? "active" : ""}>{i}</li>);
        }
        return(
            <div className="card-content">
                <div className="columns">
                    <div className="column">
                        <div className="field">
                            <div className="control">
                                <SearchForm
                                    filterText={this.state.filterText}
                                    onInput={(t) => this.handleSearchInput(t)}
                                    itemName={'equipo'}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="column">
                        <div className="field">
                            <div className="control">
                                <a className="button is-outlined is-primary" onClick={(e) => this.create()}>Agregar equipo</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="columns">
                    <div className="column">
                        <table className="table is-fullwidth">
                            <thead>
                            <tr>
                                <th>Id</th>
                                <th>Equipo</th>
                                <th>Liga</th>
                                <th>Torneo</th>
                                <th>Estatus</th>
                                <th>Acciones</th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.state.data && this.state.data.map(d => {
                                return(
                                    <tr key={d.id}>
                                        <th>{d.id}</th>
                                        <td><Link to={'/Detalles/equipo/'+d.id} >{d.team}</Link></td>
                                        <td><a href="#" title={d.league}>{d.league}</a></td>
                                        <td><a href="#" title={d.tournament}>{d.tournament}</a></td>
                                        <td>
                                            <div className="field" >
                                                <input
                                                    id={d.id}
                                                    type="checkbox"
                                                    name="status"
                                                    className="switch"
                                                    checked={parseInt(d.status) === 1}
                                                    onChange={() => {}}
                                                />
                                                <label htmlFor="status" onClick={() => {
                                                    d.status = parseInt(d.status) === 1 ? 2 : 1;
                                                    this.save(d);
                                                }}/>
                                            </div>
                                        </td>
                                        <td>
                                            <a className="button" onClick={() => this.addPlayers(d)}>
                                                <span className="icon is-small">
                                                    <i className="fas fa-user-plus"/>
                                                </span>
                                            </a>
                                            <a className="button is-warning" onClick={(e) => this.edit(d)}>
                                                    <span className="icon is-small">
                                                        <i className="fas fa-edit"/>
                                                    </span>
                                            </a>
                                            <a className="button is-danger" onClick={(e) => this.delete(d)}>
                                                    <span className="icon is-small">
                                                        <i className="fas fa-trash"/>
                                                    </span>
                                            </a>
                                        </td>
                                    </tr>

                                )
                            })
                            }
                            </tbody>
                        </table>
                        <div className='pages'>
                            <ul className='listPages'>
                                {rows}
                            </ul>
                        </div>
                    </div>
                </div>
                {this.state.showModal &&
                <Modal
                    showModal={this.state.showModal}
                    modalTitle={this.state.modalTitle}
                    data = {this.state.data}
                    cancel={() => this.closeModal()}
                >
                    <TeamForm
                        selected = { this.state.selected }
                        cancel={() => this.closeModal()}
                        save={(t)=>this.save(t)}
                        leagues={this.leagues}
                    />
                </Modal>
                }
                {this.state.addPlayersModal &&
                    <Modal
                        showModal={this.state.addPlayersModal}
                        modalTitle={'Agregar jugadores para '+this.state.selected.team}
                        cancel={() => {
                            let state = {...this.state};
                            state.addPlayersModal = false;
                            this.setState(state);
                        }}
                    >
                        <AddPlayers
                            closeModal={ () => this.closeAddPlayers()} 
                            team={this.state.selected}
                            cancel={() => {
                                let state = {...this.state};
                                state.addPlayersModal = false;
                                this.setState(state);
                            }}
                        />
                    </Modal>
                }

                {this.state.showAcceptModal &&
                <AcceptModal
                    isActive={this.state.showAcceptModal}
                    done={(t) => this.remove(t)}
                    cancel={() => {
                        let state = {...this.state};
                        state.showAcceptModal = false;
                        this.setState(state);
                    }}
                    modalTitle={"Eliminar equipo"}
                />
                }
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/team/Teams.js